module.exports = ".nodata{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n}\n.nodata .stamp{\n    font-size: 36px;\n    font-weight: 800;\n    background: #ffffff75;\n    -webkit-transform: rotateZ(-22deg);\n            transform: rotateZ(-22deg);\n    color: red;\n    text-align: center;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/chart/chart.component.css
// module id = ./src/app/chart/chart.component.css
// module chunks = main